import _defineProperty from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createBoundedBuffer, canUseEventBridge, display, displayAlreadyInitializedError, initFeatureFlags, initFetchObservable, noop, timeStampNow, buildAccountContextManager, CustomerContextKey, bufferContextCalls, addTelemetryConfiguration, buildGlobalContextManager, buildUserContextManager, setTimeout } from '@datadog/browser-core';
import { serializeLogsConfiguration, validateAndBuildLogsConfiguration } from '../domain/configuration';
export function createPreStartStrategy(getCommonContext, trackingConsentState, doStartLogs) {
  var bufferApiCalls = createBoundedBuffer(); // TODO next major: remove the globalContext, accountContextManager, userContext from preStartStrategy and use an empty context instead

  var globalContext = buildGlobalContextManager();
  bufferContextCalls(globalContext, CustomerContextKey.globalContext, bufferApiCalls);
  var accountContext = buildAccountContextManager();
  bufferContextCalls(accountContext, CustomerContextKey.accountContext, bufferApiCalls);
  var userContext = buildUserContextManager();
  bufferContextCalls(userContext, CustomerContextKey.userContext, bufferApiCalls);
  var cachedInitConfiguration;
  var cachedConfiguration;
  var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartLogs);

  function tryStartLogs() {
    if (!cachedConfiguration || !cachedInitConfiguration || !trackingConsentState.isGranted()) {
      return;
    }

    trackingConsentStateSubscription.unsubscribe();
    var startLogsResult = doStartLogs(cachedInitConfiguration, cachedConfiguration);
    bufferApiCalls.drain(startLogsResult);
  }

  return {
    init: function init(initConfiguration) {
      if (!initConfiguration) {
        display.error('Missing configuration');
        return;
      } // Set the experimental feature flags as early as possible, so we can use them in most places


      initFeatureFlags(initConfiguration.enableExperimentalFeatures);

      if (canUseEventBridge()) {
        initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
      } // Expose the initial configuration regardless of initialization success.


      cachedInitConfiguration = initConfiguration; // FIXME temporary hack to avoid sending configuration without all the context data

      setTimeout(function () {
        addTelemetryConfiguration(serializeLogsConfiguration(initConfiguration));
      });

      if (cachedConfiguration) {
        displayAlreadyInitializedError('DD_LOGS', initConfiguration);
        return;
      }

      var configuration = validateAndBuildLogsConfiguration(initConfiguration);

      if (!configuration) {
        return;
      }

      cachedConfiguration = configuration; // Instrumuent fetch to track network requests
      // This is needed in case the consent is not granted and some cutsomer
      // library (Apollo Client) is storing uninstrumented fetch to be used later
      // The subscrption is needed so that the instrumentation process is completed

      initFetchObservable().subscribe(noop);
      trackingConsentState.tryToInit(configuration.trackingConsent);
      tryStartLogs();
    },

    get initConfiguration() {
      return cachedInitConfiguration;
    },

    globalContext: globalContext,
    accountContext: accountContext,
    userContext: userContext,
    getInternalContext: noop,
    handleLog: function handleLog(message, statusType, handlingStack) {
      var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : getCommonContext();
      var date = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : timeStampNow();
      bufferApiCalls.add(function (startLogsResult) {
        return startLogsResult.handleLog(message, statusType, handlingStack, context, date);
      });
    }
  };
}

function overrideInitConfigurationForBridge(initConfiguration) {
  return _objectSpread(_objectSpread({}, initConfiguration), {}, {
    clientToken: 'empty'
  });
}